(ns practitest.frontend.navigation
  (:require [practitest.frontend.common.dom :as dom]
            [practitest.frontend.components.license-blocked-modal :as license-modal]
            [practitest.frontend.init :as init]
            [reagent.core :as reagent]
            [practitest.frontend.components.navigation :as navigation]
            [practitest.frontend.components.account-layout.account-layout :as account-layout]
            [practitest.frontend.components.notifications :as notifications]
            [re-frame.core :as re-frame]
            [practitest.frontend.events :as events]
            [practitest.frontend.subs :as subs]
            [practitest.frontend.common.re-frame :refer [partial-dispatch]]
            [practitest.frontend.common.utils :as utils]))

(defn ^:export init-old-ui [webcomponent options]
  (init/init! {:options       options
               :webcomponent  webcomponent
               :init-event-fn (fn [config]
                                [::events/initialize-db config :none])}))

(defn css-link [css-path]
  [:link {:rel  "stylesheet"
          :href css-path}])

;; Special wrapper that checks that CSS styles are already loaded before rendering
;; body, otherwise there's a split second when you can see unstyled components in shadow DOM
(defn css-loaded-wrapper [css-path body]
  (let [handler-holder (atom nil)
        counter (atom 0)
        state (reagent/atom {:loaded? false})]
    (reagent/create-class
      {:component-did-mount    (fn [this]
                                 (let [shadow-root (.-parentNode (reagent.dom/dom-node this))
                                       dom-node    (when shadow-root
                                                     (.querySelector shadow-root "div.css-loaded"))
                                       loop-fn     (fn loop-fn []
                                                     (when dom-node
                                                       (let [attempt        (swap! counter inc)
                                                             computed-style (js/window.getComputedStyle dom-node)
                                                             z-index        (.getPropertyValue computed-style "z-index")]
                                                         ;; Wait for 1 second max
                                                         (if (and (< attempt 50)
                                                                  (not= "1" z-index))
                                                           (reset! handler-holder (js/setTimeout loop-fn 20))
                                                           (swap! state assoc :loaded? true)))))]
                                   (reset! handler-holder (js/setTimeout loop-fn))))
       :component-will-unmount (fn [this]
                                 (when-let [handler @handler-holder]
                                   (js/clearTimeout handler)))
       :reagent-render         (fn [css-path body]
                                 [:<>
                                  [css-link css-path]
                                  ;; Special element to check if CSS was loaded and applied
                                  [:div.css-loaded]
                                  (when (:loaded? @state)
                                    body)])})))

(defn project-level-menu-wrapper2 []
  (let [options @(re-frame/subscribe [::subs/options])
        user-projects (or @(re-frame/subscribe [::subs/user-projects])
                          (:user-projects options))
        account-settings? (navigation/account-setting-path?)]
    [css-loaded-wrapper
     (:css-path options)
     (if account-settings?
      [account-layout/account-settings-panel (assoc options :webcomponent? true)]
      [navigation/project-level-menu
        (assoc options
               :webcomponent? true
               :user-projects user-projects
               :on-project-pin-clicked (partial-dispatch [::events/project-pin]))])]))

(defn ^:export init-project-level-menu2 [webcomponent]
  (init/init-ui! {:webcomponent          webcomponent
                  :bare?                 true
                  :root-view             project-level-menu-wrapper2
                  :after-render-callback (fn []
                                           ;; Special edge-case handler - remove "uninitialized" class after loading
                                           ;; and rendering actual menu item to prevent annoying flickering
                                           (js/setTimeout
                                             ;; Clear attribute on body
                                             #(.setAttribute webcomponent "class" "project-level-menu2")
                                             ;; TODO: fix this timeout - should not be needed
                                             100))}))

(defn system-messages-wrapper []
  (let [root-ref (atom nil)]
    (fn []
      (let [options @(re-frame/subscribe [::subs/options])
            system-messages @(re-frame/subscribe [::subs/system-messages])]
        [css-loaded-wrapper
         (:css-path options)
         [:<>
          [navigation/system-messages-bar
           (assoc options
             :webcomponent? true
             :system-messages system-messages
             :on-hide-system-message (partial-dispatch [::events/hide-system-message]))]
          [notifications/toast-container]
          ;; For shadow DOM mode we need another place to put license blocked modal page
          [:div {:ref (dom/root-ref-handler root-ref)}
           [license-modal/license-blocked-modal root-ref]]]]))))

(defn ^:export init-system-messages [webcomponent]
  (init/init-ui! {:webcomponent webcomponent
                  :bare? true
                  :root-view system-messages-wrapper}))

(defn header-wrapper2 []
  (let [options       @(re-frame/subscribe [::subs/options])
        user-projects (or @(re-frame/subscribe [::subs/user-projects])
                          (:user-projects options))
        account-settings? (navigation/account-setting-path?)]
    [css-loaded-wrapper
     (:css-path options)
     (if account-settings?
       [account-layout/account-settings-header (assoc options :webcomponent? true :account-settings? true) navigation/header-bar-buttons]
       [navigation/header-bar (assoc options
                                      :webcomponent? true
                                      :user-projects user-projects
                                      :on-project-pin-clicked (partial-dispatch [::events/project-pin]))])]))

(defn ^:export init-header2 [webcomponent]
  (init/init-ui! {:webcomponent webcomponent
                  :bare?        true
                  :root-view    header-wrapper2}))

(defn ^:dev/after-load remount-nav []
  (init/remount-roots "system-messages-component" system-messages-wrapper))

(utils/register-webcomponent! "system-messages-component")
(utils/register-webcomponent! "navigation-component")
(utils/register-webcomponent! "project-level-menu-component2")
(utils/register-webcomponent! "header-component2")
